export default __webpack_public_path__ + "static/media/crm.f56fad4f.png";